export default class myClass {
    constructor($scope,
                $routeParams,
                method,
                tipoEquipoService,
                severidadesService,
                marcasService,
                proveedorService,
                tipoOperacionService,
                $location,
                $uibModal,
                toastr) {
        this.scope = $scope;
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(tipoEquipoService);
                break;
            case 'new':
                this.create(tipoEquipoService,
                    marcasService,
                    proveedorService,
                    tipoOperacionService,
                    severidadesService);
                break;
            case 'view':
                this.view($routeParams,
                    tipoEquipoService,
                    marcasService,
                    proveedorService,
                    tipoOperacionService,
                    severidadesService);
                break;
        }
    }

    list(tipoEquipoService) {

        let self = this.scope;
        tipoEquipoService.getAll().then((resp, err) => {
            self.tipo_equipos = resp.data.message;
        });

        self.getItemPage = (item) => {
            let index = self.tipo_equipos.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, tipoEquipoService);

        /*
        this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoEquipoService.destruct({_id: id}).then((resp) => {
                    this.toastr.success('Tipo Equipo eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al eliminar tipo de equipo!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };
        */
    }

    create(tipoEquipoService,
           marcasService,
           proveedorService,
           tipoOperacionService,
           severidadesService) {

        this.scope.aux = {};
        marcasService.getAll({"grupo":'equipo'}).then((resp, err) => {
            this.scope.aux.marcas = resp.data.message;
        });

        proveedorService.getAll().then((resp, err) => {
            this.scope.aux.proveedores = resp.data.message;
        });

        tipoOperacionService.getAll().then((resp, err) => {
            this.scope.aux.tipo_operaciones = resp.data.message;
        });

        severidadesService.getAll().then((resp, err) => {
            this.scope.aux.severidades = resp.data.message;
        });

        let filterTipoEquipo = {
            sub_parte: false
        };

        tipoEquipoService.getAll(filterTipoEquipo).then((resp) => {
            this.scope.aux.tipo_equipos = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoEquipoService.save(this.scope.tipo_equipo).then((resp) => {
                    this.toastr.success('Tipo Equipo creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/tipo_equipos');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear tipo de equipo!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    view($routeParams,
         tipoEquipoService,
         marcasService,
         proveedorService,
         tipoOperacionService,
         severidadesService) {

        this.scope.aux = {};
        tipoEquipoService.getById({_id: $routeParams.id}).then((resp) => {
            this.scope.tipo_equipo = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        severidadesService.getAll().then((resp, err) => {
            this.scope.aux.severidades = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        marcasService.getAll({"grupo":'equipo'}).then((resp, err) => {
            this.scope.aux.marcas = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        tipoOperacionService.getAll().then((resp) => {
            this.scope.aux.tipo_operaciones = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        proveedorService.getAll().then((resp, err) => {
            this.scope.aux.proveedores = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        this.scope.inAction = false;
        this.scope.aux.save = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                let data = this.scope.tipo_equipo;

                tipoEquipoService.update(data)
                    .then((resp) => {
                        this.toastr.success('Tipo de equipo modificado correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        this.location.path('/tipo_equipos');
                    }).catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al actualizar tipo de equipo!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };
    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Tipo de Equipo</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el Tipo de equipo: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.destruct({_id: object._id}).then((resp) => {
                    self.scope.tipo_equipos.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Tipo de equipo eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar el Tipo de Equipo!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/tipo_equipos/tipo_equipos.js